'use strict';

import remainScrollAfterCtaAction from '../remainScrollAfterCtaAction';
import {breakpoints, toggleChatWidget, checkChatWidget, initReplaceContent, initCartCloseButton} from "../helpers/born.utils";

var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    // quickview = require('../quickview'),
    cartStoreInventory = require('../storeinventory/cart'),
    addToCart = require('./product/addToCart'),
    bornModules = require('../helpers/born.modules').default,
    minicart = require('../minicart'),
    page = require('../page'),
    tooltip = require('../tooltip'),
    stickySummary =  require('../sticky-summary'),
    customTooltip = require('./product/tooltip');

var chatWidgetExist = false;

function invalidateFormFields() {
    let $cartForm = $('.js-cart-form'),
        $jsErrorFields = $cartForm.find('.js-field-error');

    if ($jsErrorFields.length > 0) {
        $jsErrorFields.each(function () {
            let $errorField = $(this).html().trim();

            if ($errorField.length > 0) {
                let $inputField = $(this).parent().parent().find('.selectric');
                if ($inputField.length > 0) {
                    $inputField.addClass('error');
                }
            }
        });
    }
}

function loadMiniCart() {
    return new Promise((resolve) => {
        $.ajax({
            url: Urls.miniCartShow,
            type: 'GET'
        }).done(function (response) {
            minicart.replaceContent(response);
        }).fail(function () {
            page.refresh();
        }).always(function () {
            resolve();
        });
    });
}

//Common function to handle promo code UI
function togglePromoCodeInterface($coupapplied){
    const closeCouponEntry =  function(e){
        const $toggleEle  = $('.order__summary__coupon__title,.promo_title,.order__summary__coupon__entry');
        if($(e.target).hasClass('coupon--active-overlay')){
            togglePromoCodeInterface(false);
            $toggleEle.removeClass('toggle--active')
            $(".order__summary__coupon__entry .error-message").text('');
            $('input[name$="_couponCode"]').trigger('blur');
        }
    }
    if($(window).width() <= 767){
        if($coupapplied === true){
            $('html,body').addClass('cancel-scroll');
            $(".promo_title").parents('.cart-coupon-code').addClass('apply--promo-wrapper');
            $(".js-cart-summary").addClass('apply--promo-codeopen');
            $(".coupon--active-overlay").show();
            $(window).on("click",closeCouponEntry);
        }else{
            $('html,body').removeClass('cancel-scroll');
            $(".promo_title").parents('.cart-coupon-code').removeClass('apply--promo-wrapper');
            $(".js-cart-summary").removeClass('apply--promo-codeopen');
            $(".coupon--active-overlay").hide();
        }
        toggleChatWidget(false);
    }
    $('input[name$="_couponCode"]').focus();
}

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    $('#cart-table').on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });

    // override enter key for coupon code entry
    $('form input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13 && $(this).val().length === 0) { return false; }
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;

    remainScrollAfterCtaAction($('button[name$="deleteProduct"]'));

    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }
    });

    let addToCartCallback = function () {
        return new Promise((resolve) => {
            loadMiniCart().then(() => {
                bornModules.selectTags.init();
                bornModules.modalToggle.init();
                bornModules.toggle.init();
                invalidateFormFields();
                resolve();
            });
        });
    };

    addToCart(addToCartCallback);

    $("#main").on('click','.js-cart-summary .promo_title',(e)=>{
        togglePromoCodeInterface(true);
    });
    $('#main').on('click','#add-coupon', function () {
        let couponText = $('input[name$="_couponCode"]').val().trim();
        if (couponText.length) {
            $(this).css('pointer-events', 'none');
        }
    });
    var allowFormSubmit = true;
    $('#main').on('keypress','#coupon-form .coupon_txtbox',function(e){
        if(e.keyCode == 13 && !allowFormSubmit){
            e.preventDefault();
        }
    });
    $('#main').on('submit','#coupon-form', function(e) {
        allowFormSubmit = false;
    	var couponCodeObj = $('input[name$="_couponCode"]');
    	if(couponCodeObj.length > 0) {
    		if(couponCodeObj.val().trim() == '') {
    			e.preventDefault();
    			couponCodeObj.addClass('error');
    		} else {
    			couponCodeObj.removeClass('error');
    		}
    	}
    })

    initCartCloseButton();
    
    if(typeof zE !== 'undefined' && !!zE) {
        zE(function() {
           zE.hide();
        });
    }

    if($(".order__summary__coupon__entry").hasClass('toggle--active')){
        let $target =  $(".order__summary__coupon__entry .error-message").text();
        ($target != "") ? togglePromoCodeInterface(true) : togglePromoCodeInterface(false);
    }
    
    $(document).ready(function () {
        var cartLimitInterval = 0;
        var cartInterval = setInterval(function(){
            if(checkChatWidget() || cartLimitInterval > 5){
                clearInterval(cartInterval);
                chatWidgetExist = true;
                toggleChatWidget(false);
            }
            cartLimitInterval += 1;
        }, 70);
        $('.js-header-search-trigger, .header__mobile-trigger').on('click', () => {
            if ($(window).width() <= 767) {
                $('#cart-summary, .payment-modes').toggleClass('hidden');
            }
        });
        $('.search-titlebar-mobile .close-icon').on('click', () => {
            $('#cart-summary, .payment-modes').removeClass('hidden');
        })
    });
    
    window.addEventListener('load', function () {
        var cartLimitInterval = 0;
        var cartInterval = setInterval(function(){
            toggleChatWidget(false);
            if(cartLimitInterval >= 8){
                clearInterval(cartInterval);
                toggleChatWidget(false);
            }
            cartLimitInterval += 1;
        }, 1500); 
    });
    initReplaceContent('.bag-return');

    
    $('#TabbyPromoInstallments,#TabbyPromoInstallmentCopy').on('click',function() {
        var user=dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            "event": 'custom_event',
            "eventCategory": 'cart_page',
            "eventAction": 'cart_about_tabby',
            "eventLabel": 'cart about tabby click',
            "country": window.GlobalAttributes.COUNTRY,
            "language": window.GlobalAttributes.LANGUAGE,
            "screenName" : 'Cart page',
            "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
            "userId": user.user_id!=''? user.user_id : ''
        });
    })
    
    $('.order__summary__coupon__title').on('click',function() {
        var user=dataLayer.find(o => o.user != null).user;
        if($('.order__summary__coupon__title').hasClass('toggle--active')) {
            dataLayer.push({
                "event": 'custom_event',
                "eventCategory": 'cart_page',
                "eventAction": 'cart_promocode_click',
                "eventLabel": 'cart promocode click',
                "country": window.GlobalAttributes.COUNTRY,
                "language": window.GlobalAttributes.LANGUAGE,
                "screenName": 'Cart page',
                "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
                "userId": user.user_id != '' ? user.user_id : ''
            });
        }
    })
    
}

exports.init = function () {
    invalidateFormFields();
    initializeEvents();

    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }

    account.initCartLogin();
    tooltip.init();
    customTooltip.initShippingFeeCustomToolTipEvents();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/cart.js